import { render, staticRenderFns } from "./WechatTransfer.vue?vue&type=template&id=9585aeca&scoped=true"
import script from "./WechatTransfer.vue?vue&type=script&lang=js"
export * from "./WechatTransfer.vue?vue&type=script&lang=js"
import style0 from "./WechatTransfer.vue?vue&type=style&index=0&id=9585aeca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9585aeca",
  null
  
)

export default component.exports